import WrapperLayout from 'components/Layout';
import Main from './components/Main';
const DNSTwister = () => {
    return (
        <WrapperLayout>
            <Main />
        </WrapperLayout>
    )
}
export default DNSTwister